export default __webpack_public_path__ + "static/media/947.5a2b0760.png";